import * as React from 'react';
import {useState} from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import CoinUseConfirmationDialog from './CoinUseConfirmationDialog';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import {useNavigate} from 'react-router-dom';
import {URLS} from '../../constants/appConstants';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const durationCoinsMap = [{
  coin: 100,
  duration: 1
},
  {
    coin: 600,
    duration: 6
  },
  {
    coin: 1100,
    duration: 12
  },
  {
    coin: 2000,
    duration: 24
  }];

const CURRENT_BALANCE = 1000

function SimpleDialog(props) {
  const {onClose, selectedValue, open} = props;
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const navigate = useNavigate();
  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  const handleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal)
  }


  return <>
    <CoinUseConfirmationDialog
      open={showConfirmationModal} onClose={handleConfirmationModal} value={'Callisto'} coin={100} hours={1}/>
    <Dialog onClose={handleClose} open={open} fullWidth={true}>
      <Stack sx={{pr: 2, pl: 2}}>

        <DialogTitle>Select duration</DialogTitle>
        <Divider/>
        <Typography variant="body1" gutterBottom>
          Current balance: {CURRENT_BALANCE} coins
        </Typography>
        <Alert severity="info">Your question will be pinned on the top for the number of hours you
          choose.</Alert>

        <Stack
          direction="column"
          spacing={1}
          sx={{mt: 1, mb: 1}}
        >
          {durationCoinsMap.map((durationCoin) => (
            <div>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
              >
                <div><Typography variant="body1">{durationCoin.duration} hours {' '}</Typography></div>
                <div>
                  <Button variant="contained"
                          color="secondary"
                          disabled={durationCoin.coin > CURRENT_BALANCE}
                          startIcon={<KeyboardDoubleArrowUpIcon/>}
                          onClick={handleConfirmationModal}
                  >
                    {durationCoin.coin} coins
                  </Button>
                </div>
              </Stack>
            </div>
          ))}
        </Stack>
        <Divider/>
        <Box sx={{mt: 2, mb: 2, textAlign: 'center'}}>
          <Button variant="contained" startIcon={<CurrencyRupeeIcon/>} onClick={() => {
            navigate(URLS.BUY_COINS)
          }}>
            Buy coins
          </Button>
        </Box>
      </Stack>
    </Dialog>
  </>
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function CoinsModal() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen} startIcon={<KeyboardDoubleArrowUpIcon/>}>
        Boost
      </Button>
      <SimpleDialog
        open={open}
        onClose={handleClose}
      />
    </div>
  );
}
